import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ApproveRejectList from './ApproveRejectList';
import { getoffRoleEmployeesData, getDataForDropdown, } from 'services/redux/OffRoleEmployees/action';

const mapStateToProps = (state) => ({
    getEmployeesListing: state.offroleEmployeesReducer.getEmployeesListing,
    getDropdownDatas: state.offroleEmployeesReducer.getDropdownDatas
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getoffRoleEmployeesData,
        getDataForDropdown,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApproveRejectList);
